import React, { useMemo } from 'react';
import { useInView } from 'react-intersection-observer';
import { IS_SSR } from 'src/utils/helpers.utils';

export const ExploreItem: React.FC<{ height: string }> = ({ height, children }) => {
    const { ref, inView, entry }  = useInView();
    const isContentVisible = IS_SSR || inView;

    const virtualHeight = useMemo(() => {
        const rect = entry?.boundingClientRect;
        return rect?.height ? `${rect?.height}px` : height;
    }, [entry, height]);

    return (
        <div ref={ref} style={{ height: isContentVisible ? height : virtualHeight }}>
            {isContentVisible ? children : null}
        </div>
    );
};
